class ImageUploadField
  constructor: (field) ->
    @field     = field
    @form      = @field.querySelector 'form.new_image'
    @input     = @field.querySelector 'input[type="file"]'
    @preview   = @field.querySelector '.image-preview'
    @progress  = document.createElement 'progress'
    @progress.max = 100
    @progress.style.position = 'absolute'
    @progress.style.bottom = 0
    @progress.style.left = 0
    @spinner   = document.createElement 'i'
    @spinner.classList.add "fa", "fa-sync", "icon-spin"
    @image     = document.createElement 'img'

    @initialize()

  initialize: ->
    @input.addEventListener "change", (event) =>
      @progress.removeAttribute("value")
      @preview.classList.remove('hidden')
      @preview.classList.add('loading')
      @preview.append @spinner
      @readImage(event.target)
      @preview.append @progress
      progressHandler = (progressEvent) =>
        @progress.value = progressEvent.loaded / progressEvent.total * 100

      beforeSend = (xhrEvent) =>
        xhr = xhrEvent.detail[0]
        xhr.upload.addEventListener("progress", progressHandler)
        xhr.addEventListener("error", () =>
          alert('Billede upload fejl. Prøv at genindlæse siden.')
        )
        xhr.addEventListener("loadend", (e) =>
          if xhr.status >= 200 && xhr.status < 400
            @form.reset()
          else
            alert('Billede upload fejl. Prøv at genindlæse siden.')
        )

      addEventListener("ajax:beforeSend", beforeSend, { once: true })
      @form.requestSubmit()

  readImage: (input) ->
    if window.FileReader
      @preview.append @image

      reader = new FileReader()
      @image.style.opacity = 0.4

      reader.onload = (evt) =>
        @image.setAttribute 'src', evt.target.result

      reader.readAsDataURL input.files[0]

jQuery ->
  document.querySelectorAll( '.image-upload-field' ).forEach (field)->
    new ImageUploadField field
